import {gql} from '@apollo/client';

export default gql`
  mutation deleteConversionUrl($input: DeleteConversionURLInput!) {
    authed {
      success
    }
    deleteConversionUrl(input: $input) {
      success
    }
  }
`;
